import { render } from "./_form-password.vue?vue&type=template&id=32538e51"
import script from "./_form-password.vue?vue&type=script&lang=js"
export * from "./_form-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__